module.exports = __webpack_public_path__ + "static/media/chrome.d320793b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/chrome.svg
// module id = 82
// module chunks = 0